import { getCookie } from './auth-utils'

export const isTraceabilityEnabled = () => {
  const toggles = getCookie('toggleAol')
  return Boolean(toggles?.feature?.traceability)
}
